import {Dictionary} from '../interfaces/dictionary.interface';

/**
 * Get the first key of a given object
 */
export function getFirstKey(object: Dictionary): string {
  return Object.keys(object)[0];
}
